import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'components/shared';
import { EMPTY_VALUE_LABEL } from 'constants/commonLabels';

import styles from './OverviewInternalOrderIdSection.module.css';

type OverviewInternalOrderIdSectionProps = {
   internalOrderId: string;
};

const OverviewInternalOrderIdSection = ({
   internalOrderId,
}: OverviewInternalOrderIdSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('order_summary.internal_order_id')}>
         <span className={styles.labelText}>{t('order_summary.internal_order_id')}</span>
         <span className={styles.valueText}>{internalOrderId || EMPTY_VALUE_LABEL}</span>
      </SectionContainer>
   );
};

export default OverviewInternalOrderIdSection;
